// extracted by mini-css-extract-plugin
export default {"separator":"Header_separator__2-4PI","stickyHeader":"Header_stickyHeader__qLH3H","widthFull":"Header_widthFull__f276b"};